module.exports = __webpack_public_path__ + "static/instructions-b95a3156024fd17505aec03e254628df.pdf";